module.exports = __webpack_public_path__ + "static/media/usersIcon.01d00f24.svg";